//
import Model from '@/models/Model'

/**
 * 
 */
export default class ASuggestAuthCode extends Model {

    /**
     * @description
     */
    resource () {
        return 'suggest_auth_code'
    }
}